(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const setup = () => {
    document.querySelectorAll('[data-hero-parallax]').forEach((stage) => {
      if (instances.has(stage)) return;
      const image = stage.querySelector('[data-hero-image]');
      if (!image) return;
      let frame = null;
      const update = () => {
        frame = null;
        const bounds = stage.getBoundingClientRect();
        // Image moves at 82% of normal page speed; extra image height covers its travel.
        const offset = motion.matches ? 0 : Math.max(-90, Math.min(90, -bounds.top * .18));
        image.style.setProperty('--hero-offset', `${offset}px`);
      };
      const queue = () => { if (frame === null) frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      motion.addEventListener('change', queue);
      instances.set(stage, () => {
        cancelAnimationFrame(frame);
        window.removeEventListener('scroll', queue);
        window.removeEventListener('resize', queue);
        motion.removeEventListener('change', queue);
      });
      update();
    });
  };
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, stage) => {
      if (event.target.contains(stage)) { cleanup(); instances.delete(stage); }
    });
  });
  setup();
})();
